import { getIn, setIn } from 'formik';

export const objectUtil = {
  getIn,
  setIn
};
